import { TransfersAction, TransfersActionTypes, TransfersState } from '../../types/transfers'

const initialState = {
  formValue: [],
  statusFlag: false,
  inProgress: false,
  transferData: {},
  deleteTransfer: false,
  sourceComingPage: {}
}

const transfersReducer = (state = initialState, action: TransfersAction): { transferData: {}; inProgress: boolean; formValue: any[]; deleteTransfer: boolean; statusFlag: boolean, sourceComingPage: {} } => {
  switch (action.type) {
    case TransfersActionTypes.CHANGE_TABLE:
      return {
        ...state,
        formValue: action.payload,
      };
    case TransfersActionTypes.CHANGE_STATUS:
      return {
        ...state,
        statusFlag: !state.statusFlag,
      };
    case TransfersActionTypes.GET_TRANFER_BY_IBAN_REQUEST:
      return {
        ...state,
        inProgress: true,
      }
    case TransfersActionTypes.GET_TRANFER_BY_IBAN_SUCCESS:
      return {
        ...state,
        transferData: action.payload,
        inProgress: false,
      }
    case TransfersActionTypes.GET_TRANFER_BY_IBAN_FAIL:
      return {
        ...state,
      }
    case TransfersActionTypes.DELETE_TRANSFER_REQUEST:
      return {
        ...state,
        deleteTransfer: false,
      }
    case TransfersActionTypes.DELETE_TRANSFER_SUCCESS:
      return {
        ...state,
        deleteTransfer: true,
      }
    case TransfersActionTypes.DELETE_TRANSFER_FAIL:
      return {
        ...state,
        deleteTransfer: false,
      }
    case TransfersActionTypes.SET_SOURCE_COMING_PAGE:
      return {
        ...state,
        sourceComingPage: action.payload
      }
    default:
      return state;
  }
};

export default transfersReducer